<template>
  <footer>
    <div class="columns">
      <div class="column">
        <figure class="image logo">
          <img src="@/assets/logos/logo_v_mono.png" alt="">
        </figure>
      </div>
      <div class="column address" v-if="address">
        <p class="is-uppercase">Contact</p>
        <p><rich-text :elements="address.document.content" :is-root="true"></rich-text></p>
      </div>
      <div class="column">
        <p class="is-uppercase">Informations</p>
        <router-link :to="{ name: 'legal-notices' }">Mentions légales</router-link><br>
        <router-link :to="{ name: 'contact' }">Nous trouver</router-link>
      </div>
      <div class="column">
        <p class="is-uppercase">Nos partenaires</p>
        <a href="https://www.hemossante.fr/" target="_blank">hemossanté.fr</a><br>
        <a href="http://guemas-international.com/" target="_blank">guemas-international.com</a>
      </div>
      <div class="column columns networks is-mobile">
        <figure class="image column is-6">
          <a>
            <img src="@/assets/icons/facebook.svg" alt="">
          </a>
        </figure>
        <figure class="image column is-6">
          <a href="https://fr.linkedin.com/company/assurances-guemas-et-associes" target="_blank">
            <img src="@/assets/icons/linkedin.svg" alt="">
          </a>
        </figure>
      </div>
    </div>
  </footer>
</template>

<script>
import api from '@/services/api';
import RichText from '@/components/RichText.vue';

export default {
  name: 'layout-footer',
  components: {
    RichText,
  },
  data() {
    return {
      address: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.address = await api.getInfo('61df9824-960d-483e-b231-6cc9d4b15401');
    },
  },
};
</script>

<style lang="sass">
  footer
    padding: 3rem 0
    background-color: #032f56
    .logo img
      margin: 0 auto
      max-width: 300px
    .address
      .container
        width: auto
        .column
          padding: 0
    a:hover
      color: #ecf1f4
    .is-uppercase
      margin: 0 0 1rem 0
    .networks
      padding: 0
      figure:first-child img
        margin: 0 0 0 auto
      img
        padding: 0
        width: 35%
    img
      padding: 0 2.5rem
    input
      margin: 1rem 0 0 0
    a.button
      margin: 1rem 0 0 0
      border: 0
      background-color: #fe3904
    a.button, a, p
      color: #ffffff
</style>
